module.exports = __webpack_public_path__ + "img/jonas-leupe-wK-elt11pF0-unsplash.cf64437b.jpg";